import React, { useRef } from "react";
import { X, PictureInPicture2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * In-app popup video player for NON-LIVE community/uploaded videos.
 * Never redirects away. Live streams must use the dedicated Live Player instead.
 */
export default function VideoPopup({ src, poster, title, onClose }) {
  const videoRef = useRef(null);

  const pip = async () => {
    try {
      if (videoRef.current && document.pictureInPictureEnabled) {
        await videoRef.current.requestPictureInPicture();
      }
    } catch {}
  };

  return (
    <AnimatePresence>
      <motion.div
        data-testid="video-popup"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[200] bg-black/95 backdrop-blur-sm flex flex-col"
        onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      >
        <div className="flex items-center justify-between px-4 py-3 text-white/80">
          <div className="text-sm font-medium truncate max-w-[70%]">{title || "Video"}</div>
          <div className="flex items-center gap-2">
            <button onClick={pip} title="Picture in picture" className="p-2 rounded-full glass glass-hover" data-testid="video-popup-pip"><PictureInPicture2 className="w-4 h-4" /></button>
            <button onClick={onClose} className="p-2 rounded-full glass glass-hover" data-testid="video-popup-close"><X className="w-5 h-5" /></button>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center px-3 pb-4">
          <motion.video
            ref={videoRef}
            src={src}
            poster={poster}
            controls
            autoPlay
            playsInline
            initial={{ scale: 0.98, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            className="max-h-[82vh] max-w-[94vw] rounded-2xl bg-black shadow-2xl"
            data-testid="video-popup-player"
          />
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
